var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"disabled":_vm.isRunning,"size":_vm.size},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(_vm._s(_vm.tipsText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }